import { render, staticRenderFns } from "./OCR.vue?vue&type=template&id=856fac74"
import script from "./OCR.vue?vue&type=script&lang=js"
export * from "./OCR.vue?vue&type=script&lang=js"
import style0 from "./OCR.vue?vue&type=style&index=0&id=856fac74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports